import { FactoryProvider } from '@angular/core';
import { ApiConfig, FeatureFlagsConfig, Settings } from '@mri-platform/shared/core';

export const FeatureFlagsConfigProvider: FactoryProvider = {
  provide: FeatureFlagsConfig,
  useFactory: (settings: Settings, apiConfig: ApiConfig) => new FeatureFlagsConfig(settings.featureFlags, apiConfig),
  deps: [Settings, ApiConfig]
};
